import React from "react";
import "./WebDesign.css";
import "./UIDesign.css";
import bannericonsvg1 from "../Images/Frame 1171277032 (1).svg";
import bannericonsvg2 from "../Images/Frame 1171277065.svg";
import bannericonsvg3 from "../Images/Frame 1171277063.svg";
import bannericonsvg4 from "../Images/Frame 1171277064 (1).svg";
import bannerproimg from "../Images/image 588254087 (2).png";
import mobilebannerproimg from "../Images/image 588254087 (3).png";
import starimg1 from "../Images/yellow-strs 1.svg";
import profileimg1 from "../Images/Group 1171275938.png";
import projectpic1 from "../Images/image 588254101 (1).png";
import projectpic2 from "../Images/image 588254102 (2).png";
import projectpic3 from "../Images/image 588254103 (1).png";
import projectpic4 from "../Images/image (6).png";
import arrowpic from "../Images/www.lazarev.agency-7 1.svg";
import profileimg3 from "../Images/Muhammad Qasim 2 (1).png";
import lastsecimg11 from "../Images/Group 1171276771.png";
import lastsecimg22 from "../Images/Group 1171276772.png";
import vectorsvgimg from "../Images/Vector (35).svg";
import coreimg5 from "../Images/div.expertise-icon (5).svg";
import coreimg1 from "../Images/div.expertise-icon (1).svg";
import coreimg2 from "../Images/div.expertise-icon (2).svg";
import coreimg3 from "../Images/div.expertise-icon (3).svg";
import coreimg4 from "../Images/div.expertise-icon (4).svg";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";

const fadeUpAnimation = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 1, ease: "easeInOut" },
  viewport: { once: true, amount: 0.1 },
};

function UIDesign() {
  return (

    <div className="webdesign-main-div">
      {/* Section ###### No : ---------- 1  */}
      <Helmet>
        <title>UI/UX Design - Portfolio</title>
      </Helmet>
      <motion.div
        {...fadeUpAnimation}
        className="container-fluid webdesign-banner-div11 ui-ux-banner-main-div"
      >
        <div className="container">
          <div className="webdesign-banner-text-div1">
            <h1>
              UI UX <span>Design</span>
            </h1>
            <p>
              User-friendly, scalable, and conversion-ready{" "}
              <br className="d-md-block d-none" /> interfaces for{" "}
              <span>websites, web apps, and mobile apps. </span>
            </p>

            <div className="banner-book-call-web-design-btn text-center d-md-block d-none">
              <a href="https://calendly.com/iamqasim/30min" target='_blank'>
                <div>Book a Call →</div>
              </a>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Section ###### No : ---------- 2  */}

      <motion.div
        {...fadeUpAnimation}
        className="container-fluid banner-project-div11 ui-ux-banner-pro-div1"
      >
        <div className="d-md-flex d-none">
          <img src={bannerproimg} alt="" />
        </div>

        <div className="d-md-none d-block">
          <img
            src={mobilebannerproimg}
            className=" ui-ux-mobile-banner-webdesign-img"
            alt=""
          />
        </div>
        <div className="container d-block ui-ux-banner-text11">
          <div className="row">
            <div className="col-lg-3 col-6">
              <div className="webdesign-banner-text-div2 ui-ux-banner-text22 ">
                <img src={bannericonsvg1} alt="" />
                <h6>Focused User Experience</h6>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="webdesign-banner-text-div2 ui-ux-banner-text22">
                <img src={bannericonsvg2} alt="" />
                <h6>Unique Design Solutions</h6>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="webdesign-banner-text-div2 ui-ux-banner-text22">
                <img src={bannericonsvg3} alt="" />
                <h6>Scalable Digital Interfaces</h6>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="webdesign-banner-text-div2 ui-ux-banner-text22">
                <img src={bannericonsvg4} alt="" />
                <h6>Pixel-Perfect Precision</h6>
              </div>
            </div>
          </div>

          <div className="banner-book-call-web-design-btn d-md-none d-block">
            <a href="https://calendly.com/iamqasim/30min" target='_blank'>
              <div>Book a Call →</div>
            </a>
            <p>🚀 Design + Conversion, Together.</p>
          </div>
        </div>
      </motion.div>

      {/* Section ###### No : ---------- 2  */}

      <motion.div
        {...fadeUpAnimation}
        className="container-fluid core-ui-expert-div1"
      >
        <div className="container">
          <div>
            <div className="core-ui-expert-text-div1">
              <h1>
                Core UI/UX <span>Expertise</span>
              </h1>
              <p>
                Focused design solutions to build better digital experiences
                from user <br className="d-md-block d-none" /> research and
                strategy to high-fidelity UI
              </p>
            </div>

            <div className="core-ui-expert-badge-div1">
              <div>
                <p>Websites</p>
              </div>
              <div>
                <p>Web Apps</p>
              </div>
              <div>
                <p>Dashboards</p>
              </div>
              <div>
                <p>SaaS Products</p>
              </div>
              <div>
                <p>Mobile apps</p>
              </div>
              <div>
                <p>CRM System</p>
              </div>
            </div>

            <div>
              <div className="core-ui-expert-point-div1">
                <div>
                  <img src={coreimg1} alt="" />
                </div>
                <div>
                  <h2>UX Design</h2>
                  <p>
                    Crafting intuitive user journeys and seamless experiences
                    that align with your business goals and solve real user
                    problems.
                  </p>
                </div>
              </div>
              <div className="core-ui-expert-line-svg1"></div>

              <div className="core-ui-expert-point-div1">
                <div>
                  <img src={coreimg2} alt="" />
                </div>
                <div>
                  <h2>UI Design</h2>
                  <p>
                    Creating clean, high-impact interfaces that are visually
                    consistent, brand-aligned, and optimized for usability.
                  </p>
                </div>
              </div>
              <div className="core-ui-expert-line-svg1"></div>

              <div className="core-ui-expert-point-div1">
                <div>
                  <img src={coreimg3} alt="" />
                </div>
                <div>
                  <h2>UX Research</h2>
                  <p>
                    Understanding user needs through research, interviews, and
                    analysis to drive informed design decisions.
                  </p>
                </div>
              </div>
              <div className="core-ui-expert-line-svg1"></div>

              <div className="core-ui-expert-point-div1">
                <div>
                  <img src={coreimg4} alt="" />
                </div>
                <div>
                  <h2>MVP Design</h2>
                  <p>
                    Designing lean, functional MVPs to help you validate ideas,
                    attract users, and launch faster with confidence.
                  </p>
                </div>
              </div>
              <div className="core-ui-expert-line-svg1"></div>

              <div className="core-ui-expert-point-div1">
                <div>
                  <img src={coreimg5} alt="" />
                </div>
                <div>
                  <h2>Design Systems</h2>
                  <p>
                    Component-based design systems for consistency, scalability,
                    and team efficiency built directly in Figma with clear
                    documentation.
                  </p>
                </div>
              </div>
              <div className="core-ui-expert-line-svg1"></div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Section ###### No : ---------- 2  */}

      <motion.div
        {...fadeUpAnimation}
        className="container-fluid webdesign-portfolio-sec-div1"
      >
        <div className="container">
          <div className="portfolio-sec-text-div1">
            <div>
              <h1>
                <span>Proven Results,</span> Trusted by Real Clients
              </h1>
              <p>
                Design<span> that works</span> — beyond just looking good.
              </p>
            </div>
            <div className="row">
              <motion.div {...fadeUpAnimation} className="col-lg-6">
                <div className="portfolio-sec-text-div2">
                  <div>
                    <img src={projectpic1} className="img-fluid" alt="" />
                  </div>
                  <div className="portfolio-sec-text-div3">
                    <div>
                      <h2>Payever SaaS Product Design</h2>
                      <h6>Cut churn by 18% through streamlined user onboarding</h6>
                    </div>
                    <div>
                      <img src={arrowpic} alt="" />
                    </div>
                  </div>
                </div>
              </motion.div>

              <motion.div {...fadeUpAnimation} className="col-lg-6">
                <div className="portfolio-sec-text-div2">
                  <div>
                    <img src={projectpic2} className="img-fluid" alt="" />
                  </div>
                  <div className="portfolio-sec-text-div3">
                    <div>
                      <h2>Talk Asia VoIP</h2>
                      <h6>User engagement up 22% after a UX-focused redesign</h6>
                    </div>
                    <div>
                      <img src={arrowpic} alt="" />
                    </div>
                  </div>
                </div>
              </motion.div>

              <motion.div {...fadeUpAnimation} className="col-lg-6">
                <div className="portfolio-sec-text-div2">
                  <div>
                    <img src={projectpic3} className="img-fluid" alt="" />
                  </div>
                  <div className="portfolio-sec-text-div3">
                    <div>
                      <h2>Shiekh Chargha</h2>
                      <h6>Increased order completions by 25% with intuitive UI design</h6>
                    </div>
                    <div>
                      <img src={arrowpic} alt="" />
                    </div>
                  </div>
                </div>
              </motion.div>

              <motion.div {...fadeUpAnimation} className="col-lg-6">
                <div className="portfolio-sec-text-div2">
                  <div>
                    <img src={projectpic4} className="img-fluid" alt="" />
                  </div>
                  <div className="portfolio-sec-text-div3">
                    <div>
                      <h2>CAL- App Design</h2>
                      <h6>Boosted form completion rate by 30% with simplified UX flow.</h6>
                    </div>
                    <div>
                      <img src={arrowpic} alt="" />
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Section ###### No : ---------- 2  */}

      <motion.div
        {...fadeUpAnimation}
        className="container-fluid webdesign-want-sec-div1 ui-ux-process-div1"
      >
        <div className="container">
          <div className="webdesign-want-sec-div2 text-center ui-ux-process-div2">
            <div>
              <h1>
                UI/UX Design <span>Process</span>{" "}
              </h1>
              <div className="want-sec-line1"></div>

              <ul>
                <li>
                  {" "}
                  <span className="ui-span">#1</span>{" "}
                  <span>Discovery & Goals </span> – Understand the product, pain
                  points, and user goals.
                </li>
                <li>
                  {" "}
                  <span className="ui-span">#2</span>{" "}
                  <span>UX Strategy & Research</span> – Identify key flows and
                  opportunities through user research.
                </li>
                <li>
                  {" "}
                  <span className="ui-span">#3</span>{" "}
                  <span>Wireframes & User Flows</span> – Map ideas into clean,
                  intuitive wireframes.
                </li>
                <li>
                  {" "}
                  <span className="ui-span">#4</span>{" "}
                  <span>UI Design & Prototyping</span> – Create high-fidelity
                  designs tailored to your brand.
                </li>
                <li>
                  {" "}
                  <span className="ui-span">#5</span>{" "}
                  <span>Design Handoff </span> – Share clean, developer-ready
                  assets and styles.
                </li>
                <li>
                  {" "}
                  <span className="ui-span">#6</span>{" "}
                  <span>Iteration & Support </span> – Ongoing updates based on
                  feedback, analytics, or scaling.
                </li>
              </ul>
              <div className="want-sec-line1"></div>
            </div>
            <div className="want-sec-review-div1">
              <div>
                <h5>1200+</h5>
                <h5> 5 star reviews</h5>
                <img src={starimg1} className="star-web-want-sec-img1" alt="" />
                <img
                  src={profileimg1}
                  className="star-web-want-sec-img2"
                  alt=""
                />
              </div>
            </div>
            <div className="banner-book-call-web-design-btn">
              <a href="https://calendly.com/iamqasim/30min" target='_blank'>
                <div>Book a Call →</div>
              </a>
              <p>✨ Thoughtful Design. Measurable Impact.</p>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Section ###### No : ---------- 2  */}

      <motion.div
        {...fadeUpAnimation}
        className="container-fluid webdesign-choice-div1 pl-0 pr-0"
      >
        <div className="webdesign-choice-div2233">
          <div className="container">
            <div>
              <div className="web-choice-sec-img-div1">
                <img src={profileimg3} />
              </div>

              <div className="web-choice-sec-text-div">
                <h1>
                  <span className="spans11 ">Why I’m the Right Choice</span> for
                  Your <br className="d-md-block d-none" /> UI UX Design
                  <span className="spans22 "> Needs </span>
                </h1>
                <p>
                  <span>Not just a designer </span> a problem-solver focused on
                  product usability, <br className="d-md-block d-none" />{" "}
                  performance, and long-term growth.
                </p>
              </div>

              <div className="row web-choice-sec-row-div">
                <div className="col-lg-6">
                  <div className="web-choice-sec-text-div22">
                    <div>
                      <h4> 🧠</h4>
                    </div>
                    <div>
                      <h2>User-First Strategy</h2>
                      <h6>
                        Every design decision I make is backed by UX thinking{" "}
                        <br className="d-md-block d-none" /> crafted to simplify
                        flows, increase usability, and{" "}
                        <br className="d-md-block d-none" /> improve product
                        stickiness.
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="web-choice-sec-text-div22">
                    <div>
                      <h4> 📊 </h4>
                    </div>
                    <div>
                      <h2>Driven by Results</h2>
                      <h6>
                        UI/UX is more than visuals. I design to improve metrics{" "}
                        <br className="d-md-block d-none" /> like engagement,
                        retention, and task completion{" "}
                        <br className="d-md-block d-none" /> across SaaS, apps,
                        and digital products.{" "}
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="web-choice-sec-text-div22">
                    <div>
                      <h4> 🛠️ </h4>
                    </div>
                    <div>
                      <h2>End-to-End Expertise</h2>
                      <h6>
                        I’ve spent over a decade crafting websites that don’t{" "}
                        <br className="d-md-block d-none" /> just look great
                        they drive real business growth.
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="web-choice-sec-text-div22">
                    <div>
                      <h4> 🌎 </h4>
                    </div>
                    <div>
                      <h2>Worked With 200+ Clients</h2>
                      <h6>
                        I design interfaces & systems that scale across
                        industries <br className="d-md-block d-none" /> and
                        platforms.
                      </h6>
                    </div>
                  </div>
                </div>
              </div>

              <div className="request-free-btn-12">
                <a href="https://calendly.com/iamqasim/30min" target='_blank'>
                  <div>Request a Free Consultation</div>
                </a>
              </div>

              <div className="choice-design-sec-text11">
                <p>🚀 Design + Conversion, Together.</p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Section ###### No : ---------- 2  */}

      <motion.div
        {...fadeUpAnimation}
        className="container-fluid ui-ux-design-last-sec-div text-center"
      >
        <div className="container">
          <div>
            <h1>
              <span>Ready to</span> Design <br className="d-md-block d-none" />
              Something Great?
            </h1>
            <p>
              Let’s bring your digital product to life with clear,
              conversion-focused UI/UX.
            </p>
            <div className="banner-book-call-web-design-btn">
              <a href="https://calendly.com/iamqasim/30min" target='_blank'>
                <div>Book a Free Call →</div>
              </a>
              <p>🧩 UX That Fits. UI That Clicks.</p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default UIDesign;
